import { render, staticRenderFns } from "./AbroadCertificateCard.vue?vue&type=template&id=14fc6108&scoped=true&"
import script from "./AbroadCertificateCard.vue?vue&type=script&lang=js&"
export * from "./AbroadCertificateCard.vue?vue&type=script&lang=js&"
import style0 from "./AbroadCertificateCard.vue?vue&type=style&index=0&id=14fc6108&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc6108",
  null
  
)

export default component.exports